module.exports = __webpack_public_path__ + "img/logo-festa-seguros.c1de1bde.png";